module.exports = __webpack_public_path__ + "static/data-flow.461aab60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/data-flow.png
// module id = 811
// module chunks = 35783957827783